import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';
import { LandaService } from "../../core/services/landa.service";
import { AuthenticationService } from "../../core/services/auth.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() isCondensed = false;
  @Output() titleSideBar = new EventEmitter<any>();

  menu: any;
  menuItems = [];
  configData;
  user;

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(private eventService: EventService, private router: Router, private landaService: LandaService, private authService: AuthenticationService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRouting();
      }
    });
  }

  ngOnInit() {
    this.user = this.authService.getDetailUser();
    this.setAksesBackoffice();
    document.body.setAttribute('data-sidebar', 'dark');

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3
    };
  }
  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
    this.checkRouting();
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute('data-sidebar', 'light');
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (window.location.pathname === links[i]['pathname']) {
        menuItemEl = links[i];
        break;
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;

          if (parent3El) {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }

            const parent4El = parent3El.parentElement;
            if (parent4El) {
              parent4El.classList.add('mm-show');

              const parent5El = parent4El.parentElement;
              if (parent5El) {
                parent5El.classList.add('mm-active');
              }
            }
          }
        }
      }
    }
  }

  checkAkses(hakAkses) {
    return this.landaService.checkAkses(hakAkses, 'view');
  }

  checkRouting() {
    // Skip route checking for super admin users
    if (this.user && this.user.tipe === 'super admin') {
      return;
    }

    var data =
    {
      '/backoffice/invoice': ['invoice'],
      '/backoffice/voucher': ['voucher'],
      '/backoffice/klien': ['klien'],
      '/backoffice/pengaturan': ['pengaturan', 'fitur', 'paket', 'user', 'reminder_masa_aktif'],
      '/backoffice/dashboard': ['dashboard'],
      '/backoffice-new/dashboard': ['dashboard'],
      '/backoffice-new/pengaturan': ['pengaturan', 'fitur', 'paket', 'user', 'reminder_masa_aktif'],
      '/backoffice-new/klien': ['klien'],
    }
    var routing = this.router.url.split('/', 3);
    if (routing.length == 3) {
      var routingKey = String('/' + routing[1] + '/' + routing[2]);
      if (typeof (data[routingKey]) != 'undefined') {
        var isChecked = false;
        data[routingKey].forEach((val: any, key: any) => {
          if (this.checkAkses(val) == true) {
            isChecked = true;
          }
        });
        if (!isChecked) {
          this.router.navigate(['/user/pagenotfound']);
        }
      }
    }
  }

  setTitle() {
    this.titleSideBar.emit(localStorage.getItem("title"));
  }
  setAksesBackoffice() {
    this.landaService
      .DataGet('/appclient/setAksesBackoffice', this.user)
      .subscribe((res: any) => {
        this.authService.setAksesUser(res.data.akses);
        this.checkRouting();
      });
  }

  /**
  * Action logout
  */
  logout() {
    this.landaService.DataGet("/site/logout", {}).subscribe((res: any) => {
      this.authService
        .logout()
        .then((res: any) => {
          window.location.reload();
          // this.router.navigate(['/account/login']);
        })
        .catch((error) => { });
    });
  }
}
